import React from "react";

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-start justify-between mb-6">
      <div>
        <div className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">{subtitle}</div>
        <h1 className="font-display text-2xl font-bold text-[#0A192F] mt-1">{title}</h1>
      </div>
      {action}
    </div>
  );
}

export function TableShell({ children, empty, columns }) {
  return (
    <div className="bg-white border border-slate-200 rounded-md overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="text-[11px] uppercase tracking-[0.1em] text-slate-500 bg-slate-50">
          <tr>
            {columns.map((c) => (
              <th key={c} className="text-left px-4 py-2">{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>{empty ? <tr><td colSpan={columns.length}><div className="empty">{empty}</div></td></tr> : children}</tbody>
      </table>
    </div>
  );
}

export function Field({ label, testId, type = "text", value, onChange, options, ...rest }) {
  if (options) {
    return (
      <div>
        <label className="text-xs font-semibold uppercase tracking-[0.1em] text-slate-500">{label}</label>
        <select
          data-testid={testId}
          value={value ?? ""}
          onChange={onChange}
          className="mt-1 w-full text-sm px-3 py-2.5 rounded-md border border-slate-200 bg-white focus:outline-none focus:ring-2 focus:ring-slate-300"
          {...rest}
        >
          {options.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      </div>
    );
  }
  return (
    <div>
      <label className="text-xs font-semibold uppercase tracking-[0.1em] text-slate-500">{label}</label>
      <input
        data-testid={testId}
        type={type}
        value={value ?? ""}
        onChange={onChange}
        className="mt-1 w-full text-sm px-3 py-2.5 rounded-md border border-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-300"
        {...rest}
      />
    </div>
  );
}

export function Drawer({ open, onClose, title, children, footer }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex" data-testid="drawer">
      <div className="flex-1 bg-black/30" onClick={onClose} />
      <div className="w-full max-w-md bg-white h-full flex flex-col shadow-xl fade-in">
        <div className="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
          <div className="font-display font-semibold text-slate-900">{title}</div>
          <button onClick={onClose} className="text-slate-500 text-sm hover:text-slate-900" data-testid="drawer-close">Close</button>
        </div>
        <div className="flex-1 overflow-y-auto p-5">{children}</div>
        {footer && <div className="px-5 py-3 border-t border-slate-200 flex justify-end gap-2 bg-slate-50">{footer}</div>}
      </div>
    </div>
  );
}
